import { Injectable, inject } from '@angular/core';
import { Actions } from '@ngrx/effects';

@Injectable()
export class EventsEffects {
    private actions$ = inject(Actions);
}
